import React from 'react'
import { MenuCategoryHeader } from "../MenuCategory"

export function CategoryMenuHeader() {

    return(
        <nav className="categoryMenuHeader">
            <ul>
                <li className="productosNewCat">
                    <a href="/">Departamentos</a>
                    <MenuCategoryHeader />
                </li>
            </ul>
        </nav>
    )
}